import { Gender } from 'common/interfaces';

export const initialValues = {
  firstname: '',
  lastname: '',
  gender: Gender.NOT_CHOSEN,
  birthDate: '',
  retired: false,
};

export interface Partner {
  firstname: string;
  lastname: string;
  gender: Gender;
  birthDate: string;
  retired: boolean;
  options?: {
    gender: string[];
  };
}
